<aside
  class="ai-panel"
  [class.ai-panel--open]="isOpen$ | async"
  [class.ai-panel--resizing]="isResizing"
  [style.width.px]="panelWidth"
  role="dialog"
  aria-label="AI assistant">
  <!-- Drag the left edge to resize -->
  <div class="ai-panel__resizer" (mousedown)="startResize($event)" title="Drag to resize" aria-hidden="true"></div>

  <!-- Header -->
  <header class="ai-panel__header">
    <div class="ai-panel__title">
      <span class="ai-panel__avatar"><i class="pi pi-sparkles"></i></span>
      <div>
        <strong>Remmi AI</strong>
        <small>Leads</small>
      </div>
    </div>
    <div class="ai-panel__tools">
      <button type="button" class="ai-panel__newchat" title="New chat" aria-label="New chat" (click)="newChat()">
        <i class="pi pi-plus"></i>
      </button>
      <button type="button" title="Chat history" aria-label="Chat history" [class.is-active]="showHistory" (click)="toggleHistory()">
        <i class="pi pi-history"></i>
      </button>
      <button type="button" title="Close" aria-label="Close" (click)="close()"><i class="pi pi-times"></i></button>
    </div>
  </header>

  <!-- History drawer -->
  <div class="ai-panel__history" *ngIf="showHistory">
    <div class="ai-panel__history-head">
      <span class="ai-panel__history-heading"><i class="pi pi-history"></i> Recent chats</span>
      <div class="ai-panel__history-head-right">
        <span class="ai-panel__history-count" *ngIf="!historyLoading && conversations.length">{{ conversations.length }}</span>
        <button type="button" class="ai-panel__history-close" title="Close history" aria-label="Close history" (click)="toggleHistory()">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <div class="ai-panel__history-state" *ngIf="historyLoading"><i class="pi pi-spin pi-spinner"></i> Loading…</div>
    <div class="ai-panel__history-state" *ngIf="!historyLoading && !conversations.length">
      <i class="pi pi-inbox"></i> No previous conversations yet.
    </div>

    <button
      type="button"
      class="ai-panel__history-item"
      *ngFor="let c of conversations; trackBy: trackByConversation"
      (click)="loadConversation(c.id)">
      <span class="ai-panel__history-avatar">{{ historyInitial(c) }}</span>
      <span class="ai-panel__history-body">
        <span class="ai-panel__history-title">{{ c.title || 'Conversation' }}</span>
        <span class="ai-panel__history-time" *ngIf="historyTime(c)">{{ historyTime(c) }}</span>
      </span>
      <i class="pi pi-angle-right ai-panel__history-go"></i>
    </button>
  </div>

  <!-- Notice banner + body hidden while the history drawer is open -->
  <ng-container *ngIf="!showHistory">
    <!-- Notice banner (e.g. AI not configured) -->
    <div class="ai-panel__notice" *ngIf="notice$ | async as notice">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ notice }}</span>
    </div>

    <!-- Body: thread or welcome -->
    <ng-container *ngIf="messages$ | async as messages">
      <div class="ai-panel__body" [class.ai-panel__body--welcome]="!messages.length">
        <!-- Welcome: centred intro + composer grouped together -->
        <div class="ai-welcome" *ngIf="!messages.length">
          <app-ai-assistant-empty-state
            [greeting]="greeting"
            [prompt]="greetingPrompt"
            [day]="daySnapshot"
            [typing]="welcomeTyping"
            [suggestions]="(suggestions$ | async) || []"
            [capabilities]="(capabilities$ | async) || []"
            (ask)="onSend($event)"></app-ai-assistant-empty-state>
          <app-ai-assistant-composer
            class="ai-welcome__composer"
            [disabled]="(isBusy$ | async) || false"
            [seedText]="seedText"
            (send)="onComposerSend($event)"
            (draftChange)="onWelcomeDraft($event)"
            (newChat)="newChat()"></app-ai-assistant-composer>
        </div>

        <!-- Conversation -->
        <app-ai-assistant-message-list
          *ngIf="messages.length"
          [messages]="messages"
          (confirmAction)="onConfirm($event)"
          (cancelAction)="onCancel($event)"
          (viewLead)="onViewLead($event)"
          (viewLeadAppointments)="onViewLeadAppointments($event)"
          (pickPrompt)="onSend($event)"
          (provideFields)="onProvideFields($event)"
          (retry)="onRetry($event)"></app-ai-assistant-message-list>
      </div>

      <!-- Docked composer once a conversation has started -->
      <app-ai-assistant-composer
        *ngIf="messages.length"
        [disabled]="(isBusy$ | async) || false"
        [seedText]="seedText"
        (send)="onComposerSend($event)"
        (newChat)="newChat()"></app-ai-assistant-composer>
    </ng-container>
  </ng-container>
</aside>
